import {useEffect} from 'react';
import {LiveGroup} from '@/components/main/live/group/LiveGroup';
import {useParams, useNavigate} from 'react-router-dom';

export default function Live() {
  const {type} = useParams();
  const queryParams = new URLSearchParams(location.search);
  const categoryName = queryParams.get('categoryName');
  const navigate = useNavigate();

  useEffect(() => {
    if (!type || !['game', 'bora', 'sports', 'award2024'].includes(type)) {
      navigate(`/live/all`);
    }
  }, [type, navigate]);

  if (type && ['game', 'bora', 'sports', 'award2024'].includes(type)) {
    try {
      return <LiveGroup liveType={type} categoryName={categoryName} />;
    } catch (error) {}
  }
  return null;
}
